import pMap from "p-map";
import { AD_CURATION_COSTCO } from "../../components/Marketing/AdSetCostco/constants.js";
import { productService } from "./index.js";
async function getProductsInformation(itemNumbers, productConfig, locale, concurrency = 1, bdWHNumber, initialBatchSize, isProductDetailsPage, itemCuration, product_tile_data_source) {
  var _a, _b, _c;
  const {
    featureToggleConfig,
    productDetailApiConfig,
    productDetailApiV2Config
  } = productConfig;
  const callProductSummaryAPI = ((_a = featureToggleConfig == null ? void 0 : featureToggleConfig.callProductSummaryAPI) == null ? void 0 : _a.isEnabled) || product_tile_data_source === "product_summary_api";
  const mapper = async (itemNumber) => {
    try {
      const productAPIResponse = await productService(
        itemNumber,
        productConfig,
        locale,
        bdWHNumber ? bdWHNumber : "",
        itemCuration,
        product_tile_data_source
      );
      if (!productAPIResponse) return null;
      return {
        ...productAPIResponse,
        itemNumber
      };
    } catch (err) {
      console.log(err);
      return null;
    }
  };
  const batchCallMapper = async (itemNumbers2) => {
    try {
      const productAPIResponse = await productService(
        itemNumbers2,
        productConfig,
        locale,
        bdWHNumber ? bdWHNumber : "",
        itemCuration,
        product_tile_data_source
      );
      if (!productAPIResponse) return null;
      return productAPIResponse;
    } catch (err) {
      console.log(err);
      return null;
    }
  };
  if (isProductDetailsPage || !initialBatchSize || initialBatchSize >= itemNumbers.length) {
    const productApiResponses = await pMap(itemNumbers, mapper, {
      concurrency
    });
    return {
      initialResults: productApiResponses.filter((resp) => !!resp),
      remainingResultsPromise: Promise.resolve([])
    };
  }
  let initialResults = [];
  let remainingItemNumbers = itemNumbers.slice();
  const targetBatchSize = initialBatchSize;
  while (initialResults.length < targetBatchSize && remainingItemNumbers.length > 0) {
    const itemsNeeded = targetBatchSize - initialResults.length;
    let batchItemNumbers = remainingItemNumbers.slice(0, itemsNeeded);
    remainingItemNumbers = remainingItemNumbers.slice(itemsNeeded);
    let validBatchResponses = [];
    if (callProductSummaryAPI && itemCuration === AD_CURATION_COSTCO) {
      batchItemNumbers = [batchItemNumbers.join(",")];
      const batchResponses = await pMap(
        batchItemNumbers,
        batchCallMapper,
        {
          concurrency
        }
      );
      validBatchResponses = (_b = batchResponses == null ? void 0 : batchResponses[0]) == null ? void 0 : _b.filter(
        (resp) => !!resp
      );
      initialResults = [...initialResults, ...validBatchResponses];
    } else {
      const batchResponses = await pMap(batchItemNumbers, mapper, {
        concurrency
      });
      validBatchResponses = batchResponses.filter(
        (resp) => !!resp
        // Filter out null responses.
      );
      initialResults = [...initialResults, ...validBatchResponses];
    }
    if (callProductSummaryAPI && validBatchResponses.length < batchItemNumbers.length) {
      console.warn(
        `getProductsInformation: Batch fetched ${validBatchResponses.length} valid products, expected ${batchItemNumbers.length}. Missing: ${batchItemNumbers.filter(
          (num) => !validBatchResponses.some(
            (resp) => resp.itemNumber === num
          )
        )}`
      );
    }
  }
  let remainingResultsPromise = [];
  if (callProductSummaryAPI && itemCuration === AD_CURATION_COSTCO) {
    while (remainingItemNumbers.length > 0) {
      let batchRemainingItemNumbers = remainingItemNumbers.splice(
        0,
        ((_c = featureToggleConfig == null ? void 0 : featureToggleConfig.warehousePriceOnline) == null ? void 0 : _c.isEnabled) ? productDetailApiV2Config == null ? void 0 : productDetailApiV2Config.maxRequestItemCount : productDetailApiConfig == null ? void 0 : productDetailApiConfig.maxRequestItemCount
      );
      batchRemainingItemNumbers = [batchRemainingItemNumbers.join(",")];
      const remainingResults = await pMap(
        batchRemainingItemNumbers,
        batchCallMapper,
        {
          concurrency
        }
      ).then((responses) => {
        var _a2;
        return (_a2 = responses == null ? void 0 : responses[0]) == null ? void 0 : _a2.filter((resp) => !!resp);
      });
      remainingResultsPromise = [
        ...remainingResultsPromise,
        ...remainingResults
      ];
    }
  } else {
    remainingResultsPromise = pMap(remainingItemNumbers, mapper, {
      concurrency
    }).then((responses) => responses.filter((resp) => !!resp));
  }
  return {
    initialResults,
    remainingResultsPromise
  };
}
async function getProductsInformationLegacy(itemNumbers, productConfig, locale, concurrency = 1, bdWHNumber) {
  const result = await getProductsInformation(
    itemNumbers,
    productConfig,
    locale,
    concurrency,
    bdWHNumber
  );
  if (!result || !result.initialResults) {
    return [];
  }
  const remainingResults = await result.remainingResultsPromise;
  return [...result.initialResults, ...remainingResults || []];
}
export {
  getProductsInformation,
  getProductsInformationLegacy
};
